import type { Release } from '../releases';

export default {
  id: '2026-11-03-bank-statement',
  at: '2026-11-04T09:48:00Z',
  title: 'Выписку банка или 1С можно загрузить файлом — оплаты разносятся сами',
  modules: ['finance'],
  items: [
    'На вкладке «Оплаты из банка» — загрузка выписки из клиент-банка или 1С (файл в формате обмена с 1С).',
    'Каждая строка сама ищет заявку на оплату по сумме, дате, БИН и назначению и отмечает её оплаченной — оплата закрывает и плановый платёж договора.',
    'Что не нашлось, встаёт в очередь. Если по назначению понятно, к какому договору относится платёж, портал подскажет договор.',
    'После загрузки видно: сколько строк, сколько разнесено и сколько в очереди — суммы сходятся. Повторная загрузка той же выписки строк не дублирует, а файл с ошибкой не загружается вовсе, с указанием строки.',
  ],
  why: 'Оплаты попадали в портал только из money-портала; выписку банка приходилось разносить вручную, и платёж без заявки было трудно связать с договором.',
  link: '/finance?tab=bank',
} satisfies Release;
